export const RootContainerName = "overview_content";
export const RootContainerId = "root_overview_container_id";
export const ContentSectionId = "content_section_id";
export const TrailerSectionId = "trailer_section_id";
export const GoalsSectionId = "goals_section_id";
export const TrainerSectionId = "trainers_section_id";
